import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom, timeout, catchError, of } from 'rxjs';
import { DEFAULT_LANGUAGE, isSupportedLanguage, SupportedLanguage } from './language.constants';

const LOAD_TIMEOUT_MS = 15_000;

export const languageResolver: ResolveFn<SupportedLanguage> = async (route: ActivatedRouteSnapshot) => {
  const transloco = inject(TranslocoService);
  const rawLang = route.paramMap.get('lang') ?? DEFAULT_LANGUAGE;
  const lang: SupportedLanguage = isSupportedLanguage(rawLang) ? rawLang : DEFAULT_LANGUAGE;

  try {
    await firstValueFrom(
      transloco.load(lang).pipe(
        timeout(LOAD_TIMEOUT_MS),
        catchError(() => of(null)),
      ),
    );
  } catch {
    // Continue with default so the app still renders
  }

  transloco.setActiveLang(lang);
  return lang;
};
